<script setup lang="ts">
import TripCard from '../TripCard/TripCard.vue';

const itineraryStore = useItineraryStore();
const { expectedPackagesToBeSelected, currentSetIndex } =
    storeToRefs(itineraryStore);
const packageSelectStore = usePackageSelectStore();
const { selectedPackages } = classToRefs(packageSelectStore);
const packagesToShow = computed(() =>
    selectedPackages.value.filter(
        (_pkg, index) => index !== currentSetIndex.value
    )
);
const cardLabel = (index: number) => {
    if (expectedPackagesToBeSelected.value === 2) {
        const pkgs = packagesToShow.value.filter(pkg => pkg.isTripPackage());
        switch (index) {
            case 0:
                return `رفت ${dayConfig.js(pkgs[index].departureDateTime).format('D MMMM')}`;
            case 1:
                return 'برگشت';
        }
    } else {
        return `مسیر ${index}`;
    }
};
</script>

<template>
    <ClientOnly>
        <div v-show="packagesToShow.length" class="selected-packages-container">
            <template
                v-for="(tripPackage, index) in packagesToShow"
                :key="index"
            >
                <template v-if="tripPackage.isTripPackage()">
                    <TripCard
                        :trip-package
                        :custom-label="cardLabel(index)"
                        is-selected
                    />
                </template>
            </template>
        </div>
    </ClientOnly>
</template>

<style lang="scss" scoped>
.selected-packages-container {
    margin-top: 8px;
}
</style>
